import React from "react";
import {Tooltip} from "antd";
import {Countries} from "../../countries";

interface IProps {
    cdnUrl?: string;
    countryCode?: string;
    size?: number;
}

const CountryFlag: React.FC<IProps> = (props: IProps) => {
    const flagUrl = `${props.cdnUrl || "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/"}${props.countryCode?.toLowerCase() || "gb"}.svg`;
    return (
        <Tooltip title={Countries.get(props.countryCode)}>
            <img 
                className={"flag"}
                src={flagUrl}
                alt={props.countryCode?.toUpperCase()}
                style={{
                    display: "inline-block",
                    width: props.size ? props.size + "em" : "2em",
                    height: props.size ? props.size + "em" : "2em",
                    verticalAlign: "middle"
                }}
            />
        </Tooltip>
    );
};
export default CountryFlag;

CountryFlag.defaultProps = {
    cdnUrl: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/",
    countryCode: 'GB'
};